import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";
import { SiteModel } from "src/app/store/models/asset.model";
import { RoleMasterModel } from "src/app/store/models/role.model";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  public isAdminOpen = new BehaviorSubject(false);
  public userSites = new BehaviorSubject<string | []>([]);
  public isRolePermissionModal = new BehaviorSubject(false);
  public userRegions = new BehaviorSubject<SiteModel | []>([]);
  public permissionData = new BehaviorSubject<RoleMasterModel | null>(null);

  public filterSelection$ = new BehaviorSubject<{
    regions: string[];
    countries: string[];
    sites: string[];
  }>({
    regions: [],
    countries: [],
    sites: [],
  });

  adminToggleCollapse(data: boolean) {
    this.isAdminOpen.next(data);
  }
  constructor() {}
}
